import IqosMasterclass from './IqosMasterclass';
export default IqosMasterclass;
